export const USE_DEBOUNCE_TYPES = {
  TRUTHY: 'truthy',
  FALSY: 'falsy',
  TRUTH_OR_FALSY: 'truthyOrFalsy'
};
